<template>
  <v-row>
    <v-col cols="12">
      <!-- fast state -->
      <v-card>
        <v-tabs background-color="background" color="primary" grow height="55" slider-size="4">
          <v-tab class="text-none font-weight-medium" to="/invoices" exact>Todas las facturas</v-tab>
          <v-divider vertical />
          <v-tab class="text-none font-weight-medium" to="/invoices?status=draft" exact>Borradores</v-tab>
          <v-divider vertical />
          <v-tab class="text-none font-weight-medium" to="/invoices?status=finalized" exact>Por cobrar</v-tab>
          <v-divider vertical />
          <v-tab class="text-none font-weight-medium" :to="`/invoices?status=finalized&due_date__lte=${today}`" exact>Vencidas</v-tab>
          <v-divider vertical />
          <v-tab class="text-none font-weight-medium" to="/invoices?status=paid" exact>Pagadas</v-tab>
        </v-tabs>
      </v-card>
      <!-- end fast state -->

      <v-card class="px-0 mt-5">
        <v-skeleton-loader v-if="$store.state.invoices.retrieveLoader" transition="fade-transition" type="toolbar" />
        <v-toolbar v-else color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Facturas</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-query-builder :query-map="filters" model="invoice" class="mr-1" />
              <v-menu min-width="160px" close-on-click close-on-content-click offset-y left :nudge-bottom="10" transition="slide-y-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" outlined color="secondary"><v-icon left small>mdi-plus</v-icon> Nuevo</v-btn>
                </template>
                <v-list class="pa-0 text-right">
                  <v-list-item class="px-5 py-1" :to="{name: 'InvoiceCreate'}">
                    <v-list-item-title class="subtitle-2 font-weight-medium">Factura única</v-list-item-title>
                  </v-list-item>
                  <v-list-item class="px-5 py-1" :to="{name: 'InvoiceBulkListCreate'}">
                    <v-list-item-title class="subtitle-2 font-weight-medium">Facturación masiva</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="px-0 py-0">
          <invoice-list :show-create="true" />
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import { invoiceFilters } from '../../collections/queryBuilderFilters'

import InvoiceList from '@/components/invoice/InvoiceList'
import VQueryBuilder from '@/components/VQueryBuilder/VQueryBuilder'
import ListViewMixin from '@/mixins/ListViewMixin'

export default {
  components: {
    InvoiceList,
    VQueryBuilder
  },
  mixins: [
    ListViewMixin
  ],
  data: () => ({
    filters: invoiceFilters
  }),
  created () {
    this.$store.dispatch('generals/LIST', {
      resource: 'generals/documents',
      query: {
        country__id__in: `${this.account.country.id}, US`,
        is_sale: 'True'
      }
    })
    .then((response) => {
      if (response.data.results && response.data.results.length) {
        const index = this.filters.findIndex(filter => filter.id === 'document')
        this.filters[index].choices = response.data.results.map((document) => {
          return { label: document.name, value: document.id }
        })
      }
    })
  },
  methods: {
    getList () {
      this.$store.dispatch('invoices/LIST', {
        resource: 'invoices',
        query: this.$route.query
      })
    }
  }
}
</script>
